export class EmailSearchFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_from",
            "baseName": "from",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "subject",
            "baseName": "subject",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "hasAttachment",
            "baseName": "hasAttachment",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EmailSearchFilter.attributeTypeMap;
    }
    constructor() {
    }
}
